const equal = (a, b) => JSON.stringify(a ?? "") === JSON.stringify(b ?? "");
const immutable = new Set(["id", "creadoEn", "actualizadoEn", "historialEtapas", "historialEdiciones", "historialAsignaciones", "actorId", "actorNombre"]);
export function draftPatch(base, draft, current) {
  if (!current || current.archivado) throw new Error("Este registro ya no está disponible. Tu borrador se conserva; puedes copiarlo antes de cerrar.");
  const patch = {};
  for (const key of Object.keys(draft)) {
    if (immutable.has(key) || equal(base[key], draft[key])) continue;
    if (!equal(base[key], current[key]) && !equal(draft[key], current[key])) throw new Error("El campo " + key + " cambió en otra sesión. Tu borrador se conserva; revisa la versión actual antes de guardar.");
    patch[key] = draft[key];
  }
  return patch;
}
export function draftChanged(base, current) {
  return Boolean(base && (!current || Object.keys(base).some(key => !immutable.has(key) && !equal(base[key], current[key]))));
}
